import React from 'react';

import Link from 'next/link';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import useWindowSize from '@components/common/hooks/useWindowSize';
import { M_DEVICE } from '@components/lpc/Constants';
import Card from '@components/lpc/SolidarityLanding/Hero/Card/Card';
import TrustBox, { TemplatesTypes } from '@components/lpc/TrusBox/TrustBox';
import { potCreationTypeEnum } from '@models/PotModel/createPotCategoryModel';
import { ROUTE } from '@services/http/Route';

import css from './Hero.module.scss';

const Hero = () => {
    const { t } = useTranslateLpc('lpc-solidarity-page');
    const { width } = useWindowSize();
    const cardCount = width > M_DEVICE ? parseInt(t('hero.actions.size')) : parseInt(t('hero.actions.size')) - 2;

    const cards = Array.from({ length: cardCount }, (_, articleIndex) => (
        <Card articleIndex={articleIndex} key={`card-${articleIndex}`} />
    ));

    const elements = width > M_DEVICE ? new Array(20).fill(null).map(() => <>{cards}</>) : cards;

    return (
        <div className={css.shadow_inset_white}>
            <div className={css.hero_container}>
                <div className={css.hero_container__left_side}>
                    <TrustBox dataTemplateId={TemplatesTypes.MICRO_STAR} customClass={css.hero_container__trust_box} />
                    <h1>
                        {t('hero.title')}
                        <span className={css.hero_container__left_side__sub_title}>{t('hero.subtitle')}</span>
                    </h1>
                    <h2>{t('hero.description')}</h2>
                    <Link
                        href={{
                            pathname: ROUTE.LPC.POT.CREATE_POT,
                            query: {
                                category: potCreationTypeEnum.LPS,
                                utm_source: potCreationTypeEnum.LPS,
                            },
                        }}
                    >
                        <Button customClass={css.hero_container__left_side__cta} variant={'primary'}>
                            {t(`pool_creation.create`)}
                        </Button>
                    </Link>
                </div>
                <div className={`${css.hero_container__right_side} ${css.animate_scroll_up}`}>
                    <div className={css.hero_container__right_side__container}>{elements}</div>
                    {width <= M_DEVICE && (
                        <div className={css.hero_container__right_side__container}>
                            {Array.from({ length: parseInt(t('hero.actions.size')) - 3 }, (_, articleIndex) => (
                                <Card articleIndex={articleIndex + 3} key={articleIndex} />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
export default Hero;
